import { A11y, Autoplay, default as Swiper, default as SwiperCore, EffectFade, Keyboard, Pagination } from 'swiper';
import 'swiper/css/bundle';
import { PaginationTypes } from '../../../libs/gin-tonic/components/swiper';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

SwiperCore.use([Pagination, A11y, Autoplay, EffectFade, Keyboard]);

declare let ScrollMagic: any;
declare let TimelineMax: any;
declare let TweenMax: any;
declare let Linear: any;

export const ScrollMagicController = new ScrollMagic.Controller();

@Component({className: 'js-case-slider'})
export class CaseSliderComponent {
	private duration = .3;
	private delay = .15;
	private autoplay = false;
	private autoplayDelay = 0;

	constructor(private element: HTMLElement) {
		this.initSwiper(element);
		this.initPlayButton();
	}

	private initPlayButton() {
		const triggers = this.element.querySelectorAll<HTMLElement>('.js-case-slider-play-btn');
		triggers.forEach(trigger => {
			trigger.addEventListener('click', () => {
				const videoEl = trigger.parentElement.querySelector<HTMLElement>('[data-player-src]');
				videoEl.click();
			})
		})
	}

	private initSwiper(element: HTMLElement) {
		const autoplayDelay = (parseInt(this.element.getAttribute('data-swiper-autoplay')) || 0);
		if(autoplayDelay > 0) {
			this.autoplay = true;
			this.autoplayDelay = autoplayDelay * 1000;
		} else {
			this.setInitial();
		}

		new Swiper(element, {
			cssMode: false,
			speed: 500,
			loop: true,
			keyboard: true,
			allowTouchMove: false,
			simulateTouch: false,
			autoplay: this.autoplay ? {
				delay: this.autoplayDelay,
				disableOnInteraction: true,
			} : false,
			pagination: {
				el: this.element.querySelector<HTMLElement>('.swiper-pagination'),
				clickable: true,
				type: PaginationTypes.bullets,
			},
			on: {
				transitionStart: (swiper) => {
					this.getActiveSlideTween(swiper.slides[swiper.activeIndex]);
				},
			},
		});
	}

	private setInitial() {
		new ScrollMagic.Scene({
			triggerElement: this.element,
			triggerHook: .8,
		})
			.setTween([
				this.getActiveSlideTween(this.element)],
			)
			.addTo(ScrollMagicController);
	}

	private getActiveSlideTween(slide) {
		const tl = new TimelineMax();
		const tweens = [];

		const staggerTargets = slide.querySelectorAll('.js-case-slider-stagger');
		if(staggerTargets.length > 0) {
			tweens.push(TweenMax.fromTo(
				staggerTargets,
				this.duration,
				{
					css: {translateY: 50, opacity: 0},
				},
				{
					css: {translateY: 0, opacity: 1},
					ease: Linear.easeInOut,
					stagger: this.duration / 2,
				},
			));
		}

		const opacityTargets = slide.querySelectorAll('.js-case-slider-opacity');
		if(opacityTargets.length > 0) {
			tweens.push(TweenMax.fromTo(
				opacityTargets,
				this.duration / 2,
				{
					css: {opacity: 0},
				},
				{
					css: {opacity: 1},
					ease: Linear.easeInOut,
					delay: this.delay,
				},
			));
		}

		const clipTargets = slide.querySelectorAll('.js-case-slider-clip');
		if(clipTargets.length > 0) {
			tweens.push(TweenMax.fromTo(
				clipTargets,
				this.duration,
				{
					css: {scale: .9, clipPath: 'polygon(10% 10%, 100% 10%, 100% 100%, 10% 100%)'},
				},
				{
					css: {scale: 1, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'},
					ease: Linear.easeInOut,

				},
			));
		}
		tl.add(tweens);
		tl.delay(.35);

		return tl;
	}
}
